import React, { useState } from 'react';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import Team from './components/Team';

const App: React.FC = () => {
  return (
    <div className="flex flex-col items-center">
      <Navbar />

      <main className="w-screen">
        <Home isVisible={true}/>
        <About isVisible={true}/>
        <Team isVisible={true}/>
        <Services isVisible={true}/>
        <Gallery />
        <Contact />
      </main>
      
      <Footer />
    </div>
  );
};

export default App;